<template>
  <div class="main">
    <div class="top">
      <headline ref="headline" :statusName="statusName" :params="params" :logo-width="logoWidth" :is-fold="menuFold"></headline>
    </div>
    <div class="substance"  :class="{'is-UnifiedContentLibrary':isLibraryDetail}">
      <slide ref="slide" v-if="slideOn" v-on:getToggle="getToggle" v-on:passRoutes="passRoutes"></slide>
      <router-view :style="{marginLeft: menuFold ? `${menuFoldWidth}px` : `${menuExpandWidth}px`}" @statusChange="statusChange" v-on:filterData="passFilter" ref="content"></router-view>
      <div v-show="componentName === 'unifiedContentLibrary'" id="library-content" style="flex: 1; overflow:hidden;"></div>
      <div v-show="componentName === 'onlinePlayingLibrary'" id="onLinePlaying-content" style="flex: 1; overflow:hidden;"></div>
    </div>
  </div>
</template>

<script>
import headline from '@components/headline'
import slide from '@components/slide'

export default {
  name: 'mainPage',
  props: {
    params: {
      type: Object,
      require: true
    }
  },
  data (){
    return {
      //默认导航菜单显示
      slideOn: true,
      menuFold: false, // 菜单收起状态
      menuFoldWidth: 72,
      menuExpandWidth: 230,
      isXnew: true,
      statusName: '',
      logoWidth: 230,
      cachedViews: ['unifiedContentLibrary']
    }
  },
  computed: {
    isLibraryDetail(){
      return this.$store.state.unifiedContentLibrary.isDetail
    },
    componentName(){
      console.log('componentNamecomponentName',this.$route.name)
      return this.$route.name
    }
  },
  watch: {
    params(value) {
      //console.log('new title', value)
    },
    $route(){
      this.slideOn = true;
      this.setLogoWidth()
    }
  },
  components: {
    headline,
    slide
  },
  methods: {
    statusChange(status){
      console.log(status)
      this.statusName = status
    },
    setLogoWidth(){
      const name = this.$route.name
      if(name === 'unifiedContentLibrary') {
        this.logoWidth = this.menuFoldWidth
      }else {
        this.logoWidth = this.menuExpandWidth
      }
    },
    passFilter(d) {
      this.$refs.headline.passFilterData(d)
    },
    getToggle(s) {
      // 获取菜单展开收起状态
      this.menuFold = s
      // 控制子页面底部悬浮栏宽度变化
      const footLineGap = s ? this.menuFoldWidth : this.menuExpandWidth
      if(this.$refs.content) {
        this.$refs.content.footLineGap = footLineGap
      }
    },
    passRoutes(r) {
      // 传递路由信息
      this.$refs.headline.getRoutes(r)
    }
  },
  created() {
    let domin = window.document.domain;
    let isXnew = true;
    if(domin.indexOf('xnews')!=-1){
      isXnew = true
    }else if(domin.indexOf('localhost')!=-1){
      isXnew = true
    }else{
      isXnew = false
    }
    this.isXnew = isXnew;

    // this.$AiMessage()
  },
  mounted() {
    this.setLogoWidth()
  }
}
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  height: auto;
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  .top {
    width: 100%;
    min-width: 1134px;
    height: 70px;
    position: fixed;
    z-index: 1001;
  }
  .substance {
    flex: 1;
    display: flex;
    height: auto;
    padding-top: 70px;
    .slide {
      width: 230px;
      height: 100%;
      flex-shrink: 0;
      position: fixed;
      z-index: 999;
      // overflow-y: auto;
      &::-webkit-scrollbar {
          width: 0;
          height: 0;
      }
    }
    .content {
      flex: 1;
      height: auto;
      min-width: 1105px;
      padding: 30px 20px;
      margin-left: 230px;
    }
    &.is-UnifiedContentLibrary {
      .slide {
        width: 0!important;
      }
      .library-content-placeholder,
      #library-content {
        margin-left: 0!important;
      }

    }
  }
}
</style>
